import {Breadcrumbs, Link, makeStyles, Typography} from "@material-ui/core";
import React, {FC} from "react";
import {NavLink} from "react-router-dom";

const useStyles = makeStyles(theme => ({
  linkItem: {
    textDecoration: "none",
    color: "inherit",
    '&:hover': {
      textDecoration: "none!important"
    },
  },
  selected: {
    '&:hover': {
      textDecoration: "none!important"
    },
    '&.MuiTypography-root': {
      textDecoration: "none",
      background: "linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%)!important",
      "-webkit-background-clip": "text!important",
      "-webkit-text-fill-color": "transparent!important"
    },

  }
}))

type PropsType = {
  data: {name: string, link: string}[]
}

const CustomBreadcrumbs: FC<PropsType> = ({data}) => {
  const styles = useStyles();

  return (
    <Breadcrumbs aria-label="Breadcrumb">
      {data.map((i, index) => (
        index === data.length - 1 ?
          <Typography key={index} className={styles.selected}>{i.name}</Typography> :
          <Link key={index} component={NavLink} exact to={i.link} className={styles.linkItem}>
            {i.name}
          </Link>
      ))}
    </Breadcrumbs>
  )
}

export default CustomBreadcrumbs